import { ref } from "vue";

/**
 * Prompt global de "upgrade de plano" — disparado quando o backend recusa uma
 * ação por limite/módulo do plano (409 CORRENTE_LIMIT_REACHED / 403
 * MODULE_NOT_IN_PLAN). Singleton por módulo (fora de componente) para poder ser
 * chamado do interceptor do axios; um único <UpgradeDialog/> no App.vue reage.
 */
const open = ref(false);
const message = ref("");

export function promptUpgrade(msg?: string) {
	message.value = msg || "";
	open.value = true;
}

export function useUpgradePrompt() {
	function close() {
		open.value = false;
	}
	return { open, message, promptUpgrade, close };
}
